module.exports = __webpack_public_path__ + "img/food-modal-icon.eff73627.svg";